import { getCheckoutClient } from '../../../config/CheckoutClient';
import { addServerErrors } from '../../../actions/ui';
import { getMemberPayload } from '../../../selectors/request';
import { isEmail } from '@showclix-shared-util/validators';

export function setName(name, fromFetch = false) {
    return { type: "SET_MEMBER_NAME", name, fromFetch };
}

export function setEmail(email, fromFetch = false) {
    return { type: "SET_MEMBER_EMAIL", email, fromFetch };
}

export function setPhone(phone, fromFetch = false) {
    return { type: "SET_MEMBER_PHONE", phone, fromFetch };
}

export function setAddress(address, fromFetch = false) {
    return { type: "SET_MEMBER_ADDRESS", address, fromFetch };
}

export function setSaved(value) {
    return { type: "SET_MEMBER_SAVED", value };
}

export function setEmailOptOut(value) {
    return { type: "SET_MEMBER_EMAIL_OPT_OUT", value };
}

//modify initial state to change the default value
export function setDefaultEmailOptOut(value) {
    return { type: "SET_DEFAULT_MEMBER_EMAIL_OPT_OUT", value };
}

export function setCreatedNewAccount(value) {
    return { type: "SET_MEMBER_CREATED_NEW_ACCOUNT", value };
}

export function setMemberFieldError(field, error) {
    return {
        type: "SET_MEMBER_FIELD_ERROR",
        payload: {
            field,
            error
        }
    }
}

export function setMemberID(value) {
    return { type: "SET_MEMBER_ID", value };
}

export function setOrderCount(value) {
    return { type: "SET_ORDER_COUNT", value };
}

export function reportPersonalDetailsChanged(value) {
    return { type: "REPORT_PERSONAL_DETAILS_CHANGED", value };
}


const validateName = (name) => {
    let [firstName, lastName] = name.trim().split(" ").filter(Boolean)

    if (!lastName) {
        return {
            message: 'checkout__invalid_member_name',
        }
    }

    // Check if first name and last name contain at least one alpha character
    const hasLetter = /\p{L}/u;

    if (!hasLetter.test(firstName) || !hasLetter.test(lastName)) {
        return {
            message: 'Checkout__full_name_requires_alpha_characters',
        };
    }
}

const validateEmail = (email) => {
    if (!isEmail(email)) {
        return {
            message: 'checkout__invalid_email_pattern'
        }
    }
}

const memberValidators = {
    name: validateName,
    email: validateEmail
}

export function validateMemberField(field) {
    return (dispatch, getState) => {
        const state = getState();

        if (!(field in state.member)) return;

        const value = state.member[field];

        if (!value) {
            dispatch(setMemberFieldError(field, { message: 'checkout__member_required_field' }));
            return false;
        }

        const validate = memberValidators[field];

        if (!validate) return;

        const error = validate(value);

        if (error) {
            dispatch(setMemberFieldError(field, error));
            return false;
        }

        // Clear error
        dispatch(setMemberFieldError(field, undefined));

        return true;
    }
}

export function reportNameEmailChange() {
    return (dispatch, getState) => {
        const state = getState();
        const name = state.member.name;
        const email = state.member.email;

        if (name && email) {
            dispatch(reportPersonalDetailsChanged({ name, email }));
        }
    }
}

export function submitMemberInfo() {
    return (dispatch, getState) => {
        let state = getState();
        let payload = getMemberPayload(state);

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'customer', payload, state.reservation.secret).then((result) => {
            dispatch(setSaved(true));
        }).catch((error) => {
            if (error.response.statusCode === 400) {
                dispatch(addServerErrors(error.response.body.errors));
                return Promise.reject("");
            }
        });
    }
}

export function refetchMember() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const state = getState();
            getCheckoutClient(state.ui.apiUrl)
                .reservationGetRequest(state.reservation.token, 'customer', state.reservation.secret)
                .then((result) => {
                    try {
                        if (result?.ok && result.body?.data?.attributes
                            && Object.keys(result.body.data.attributes).length > 0) {
                            handleMemberFetch(dispatch, result.body.data.attributes);
                            resolve();
                        }
                    } catch (e) {
                        Promise.reject();
                    }

                    Promise.reject();
                });
        });
    }
}

export function fetchMember(token, secret) {
    return (dispatch, getState) => {
        const state = getState();
        return getCheckoutClient(state.ui.apiUrl)
            .reservationGetRequest(token, 'customer', secret)
            .then((result) => {
                if (result?.ok && result.body?.data?.attributes
                    && Object.keys(result.body.data.attributes).length > 0) {
                    handleMemberFetch(dispatch, result.body.data.attributes);
                    return Promise.resolve();
                }
            });
    };
}

function handleMemberFetch(dispatch, memberAttributes) {
    let fullName = "";
    if (memberAttributes.first_name && memberAttributes.last_name) {
        fullName = memberAttributes.first_name + ' ' + memberAttributes.last_name;
    }
    dispatch(setMemberID(memberAttributes.user_id));
    dispatch(setName(fullName, true));
    dispatch(setEmail(memberAttributes.email, true));
    dispatch(setPhone(memberAttributes.phone, true));
    dispatch(setAddress({
        name: fullName,
        address: memberAttributes.address,
        address2: memberAttributes.address2,
        state: memberAttributes.state,
        city: memberAttributes.city,
        country: memberAttributes.country,
        zip: memberAttributes.zip
    }, true));
}
